(function(){
  'use strict';
  var d=document;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money=function(c){var v=(c/100).toFixed(2).replace('.',',');return '€'+v.replace(',00','');};
  function toast(msg){var t=d.getElementById('cavaToast');if(!t)return;t.textContent=msg;t.classList.add('is-visible');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('is-visible');},2600);}
  window.cavaToast=toast;

  function initHeader(){
    var hd=d.querySelector('.hd');if(!hd)return;
    function onScroll(){hd.classList.toggle('is-scrolled',window.scrollY>30);}
    window.addEventListener('scroll',onScroll,{passive:true});onScroll();

    /* mega menu drops — hover met 200ms delay zodat gap overbrugd wordt */
    d.querySelectorAll('[data-drop]').forEach(function(drop){
      var btn=drop.querySelector('button');if(!btn)return;
      var closeTimer;

      /* click toggle (ook mobiel touch) */
      btn.addEventListener('click',function(){
        var isOpen=drop.classList.contains('is-open');
        d.querySelectorAll('[data-drop]').forEach(function(x){
          x.classList.remove('is-open','is-hover');
          var b=x.querySelector('button');if(b)b.setAttribute('aria-expanded','false');
        });
        if(!isOpen){drop.classList.add('is-open');btn.setAttribute('aria-expanded','true');}
      });

      /* hover open direct, hover close na 200ms — overbrugt de visuele gap */
      drop.addEventListener('mouseenter',function(){
        clearTimeout(closeTimer);
        drop.classList.add('is-hover');
      });
      drop.addEventListener('mouseleave',function(){
        closeTimer=setTimeout(function(){drop.classList.remove('is-hover');},200);
      });
    });

    /* klik buiten dropdown sluit alles */
    d.addEventListener('click',function(e){
      if(!e.target.closest('[data-drop]')){
        d.querySelectorAll('[data-drop]').forEach(function(x){x.classList.remove('is-open','is-hover');});
      }
    });
  }

  function initReveal(){
    var els=[].slice.call(d.querySelectorAll('.shead, .cat, .card, .val, .story__content, .story__media, .faq details, .nl h2, .nl p, .nl form'));
    if(reduced||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in-view');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in-view');io.unobserve(en.target);}});
    },{threshold:.1,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e,i){e.classList.add('reveal');e.style.transitionDelay=(i%4)*70+'ms';io.observe(e);});
  }

  function initMenu(){
    var nav=d.getElementById('mnav'),open=d.getElementById('navOpen'),close=d.getElementById('navClose');
    if(!nav||!open)return;
    open.addEventListener('click',function(){nav.classList.add('is-open');d.body.classList.add('menu-open');});
    close.addEventListener('click',function(){nav.classList.remove('is-open');d.body.classList.remove('menu-open');});
    nav.addEventListener('click',function(e){if(e.target.tagName==='A'){nav.classList.remove('is-open');d.body.classList.remove('menu-open');}});

    /* mobiel accordion: knoppen met data-mnav-acc klappen sub open/dicht */
    d.querySelectorAll('[data-mnav-acc]').forEach(function(accBtn){
      accBtn.addEventListener('click',function(){
        accBtn.classList.toggle('is-open');
        var sub=accBtn.nextElementSibling;
        if(sub&&sub.dataset.mnavSub!==undefined)sub.classList.toggle('is-open');
      });
    });
  }

  function setCount(n){d.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=n;el.style.display=n>0?'':'none';});}

  function initAjaxForms(){
    d.querySelectorAll('form[data-ajax-cart]').forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var btn=form.querySelector('[type=submit]');
        if(btn)btn.disabled=true;
        fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
          .then(function(r){if(!r.ok)throw r;return r.json();})
          .then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
          .then(function(cart){setCount(cart.item_count);toast('In je winkelwagen ◈');})
          .catch(function(){toast('Kon niet toevoegen — check je maat.');})
          .finally(function(){if(btn)btn.disabled=false;});
      });
    });
  }

  function initPDP(){
    var root=d.querySelector('[data-pdp]');if(!root)return;
    var jsonEl=root.querySelector('[data-product-json]');if(!jsonEl)return;
    var product=JSON.parse(jsonEl.textContent);
    var selected=[];
    var booted=false;
    var priceEl=root.querySelector('[data-price]'),compareEl=root.querySelector('[data-compare]'),saveEl=root.querySelector('[data-save]');
    var idInput=root.querySelector('input[name=id]');
    var atc=root.querySelector('[data-atc]');var atcText=atc?atc.querySelector('span'):null;
    var stickyAtc=d.querySelector('[data-sticky-atc]');

    root.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx=parseInt(group.dataset.optIndex,10);
      var first=group.querySelector('.optbtn.is-active')||group.querySelector('.optbtn');
      if(first){first.classList.add('is-active');selected[idx]=first.dataset.value;}
      group.addEventListener('click',function(e){
        var b=e.target.closest('.optbtn');if(!b)return;
        group.querySelectorAll('.optbtn').forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active');selected[idx]=b.dataset.value;
        var lbl=group.querySelector('[data-opt-current]');if(lbl)lbl.textContent=b.dataset.value;
        update();
      });
    });

    /* sticky selectors — dubbele rAF voorkomt scroll-naar-boven op mobiel */
    d.querySelectorAll('[data-sticky-opt]').forEach(function(sel){
      var idx=parseInt(sel.dataset.stickyOpt,10);
      if(selected[idx])sel.value=selected[idx];
      sel.addEventListener('change',function(){
        var group=root.querySelector('[data-opt-index="'+idx+'"]');
        if(!group)return;
        var btn=Array.prototype.find.call(group.querySelectorAll('.optbtn'),function(b){return b.dataset.value===sel.value;});
        if(btn){
          var savedY=window.scrollY;
          btn.click();
          /* dubbele rAF: eerste frame = DOM-update, tweede frame = na paint — dan pas scroll herstellen */
          requestAnimationFrame(function(){
            requestAnimationFrame(function(){window.scrollTo(0,savedY);});
          });
        }
      });
    });

    function currentVariant(){
      return product.variants.find(function(v){return selected.every(function(val,i){return v.options[i]===val;});});
    }
    function showVariantImage(v){
      if(!v.featured_image||!v.featured_image.src)return;
      var base=v.featured_image.src.split('?')[0].split('/').pop().replace(/\.[a-zA-Z]+$/,'');
      var imgs=root.querySelectorAll('.pdp__stream img');
      for(var i=0;i<imgs.length;i++){
        if(imgs[i].src.indexOf(base)>-1){
          var fr=imgs[i].closest('.pdp__frame');
          if(fr)fr.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest',inline:'center'});
          break;
        }
      }
    }
    function update(){
      var v=currentVariant();
      selected.forEach(function(val,i){
        var s=d.querySelector('[data-sticky-opt="'+i+'"]');
        if(s&&val&&s.value!==val)s.value=val;
      });
      if(!v){if(atc){atc.disabled=true;if(atcText)atcText.textContent='Niet beschikbaar';}return;}
      if(idInput)idInput.value=v.id;
      if(priceEl)priceEl.textContent=money(v.price);
      if(compareEl){
        if(v.compare_at_price>v.price){compareEl.style.display='';compareEl.textContent=money(v.compare_at_price);if(saveEl){saveEl.style.display='';saveEl.textContent='Bespaar '+money(v.compare_at_price-v.price);}}
        else{compareEl.style.display='none';if(saveEl)saveEl.style.display='none';}
      }
      if(atc){atc.disabled=!v.available;if(atcText)atcText.textContent=v.available?(atc.dataset.label||'Toevoegen'):'Uitverkocht';}
      var st=d.querySelector('[data-sticky-price]');if(st)st.textContent=money(v.price);
      if(booted)showVariantImage(v);
    }
    if(stickyAtc&&atc&&'IntersectionObserver' in window){
      var sBtn=stickyAtc.querySelector('.pdp-sticky__row:last-child button:not(.pdp-sticky__up)');
      if(sBtn)sBtn.addEventListener('click',function(){atc.click();});
      var upBtn=stickyAtc.querySelector('.pdp-sticky__up');
      if(upBtn)upBtn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
      new IntersectionObserver(function(en){
        var e=en[0];
        stickyAtc.classList.toggle('is-visible',!e.isIntersecting&&e.boundingClientRect.top<0);
      },{threshold:0}).observe(atc);
    }
    update();
    booted=true;
  }

  function initCart(){
    d.querySelectorAll('[data-qty]').forEach(function(q){
      var input=q.querySelector('input');
      q.addEventListener('click',function(e){
        var b=e.target.closest('button');if(!b)return;
        var v=parseInt(input.value,10)||1;
        input.value=Math.max(0,v+(b.dataset.dir==='up'?1:-1));
        input.form&&input.form.submit();
      });
    });
  }

  function initSort(){
    var s=d.querySelector('[data-sort]');if(!s)return;
    s.addEventListener('change',function(){
      var u=new URL(location.href);u.searchParams.set('sort_by',s.value);location.href=u.toString();
    });
  }

  function init(){
    initHeader();initMenu();initAjaxForms();initPDP();initCart();initSort();initReveal();
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){setCount(c.item_count);}).catch(function(){});
  }
  if(d.readyState==='loading'){d.addEventListener('DOMContentLoaded',init);}else{init();}
})();
